/**
 * @generated SignedSource<<fbf20b7b7c1c5a823e8231269f44cdec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileActions_User$data = {
  readonly " $fragmentSpreads": FragmentRefs<"user_useIsClient" | "user_useIsGuest" | "user_useIsRealAdmin">;
  readonly " $fragmentType": "ProfileActions_User";
};
export type ProfileActions_User$key = {
  readonly " $data"?: ProfileActions_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileActions_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileActions_User",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsGuest"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsRealAdmin"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsClient"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "463fe796e644020466164f6393bd47bd";

export default node;
